import script from "./TagsInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsInput.vue?vue&type=script&setup=true&lang=js"

import "./TagsInput.vue?vue&type=style&index=0&id=9d7fbb74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d7fbb74"]])

export default __exports__